import { schema } from 'normalizr';

export const location = new schema.Entity('locations');
export const locationList = [location];



// WEBPACK FOOTER //
// ./src/modules/locations/schema.js